import type { FaireProductEntity } from "../../entity_types/product";

export const p_buwyasv924: FaireProductEntity = {
  token: "p_buwyasv924",
  type: "product",
  name: "Easter Basket Stuffers – Mini Bunny Bath Bombs – Case of 6",
  brandToken: "b_1a60a447",
  brandName: "Roxy Grace",
  imageUrl:
    "https://cdn.faire.com/fastly/5321ac5345e0bc9095bf4c18dce40d87331135b09c507aa92eb1ebc092457cba.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d6d4da562dad76de6ccf0c53601e5aa8924658408ce0cdac130676e415e8130e.webp",
    "https://cdn.faire.com/fastly/0caae7c4b27a85bf9422624c84ac2d600cb3d77f466dc01e118e3feed77eabd0.jpeg",
    "https://cdn.faire.com/fastly/982151b4bfed90d4cd20a5b40511be4342c0d44bdf597597d93d24f439244c12.jpeg",
    "https://cdn.faire.com/fastly/e7e93e28e1e461e7810473456a5225d649f00b1c26a75986bb16b6428c95bb80.jpeg",
    "https://cdn.faire.com/fastly/74cb2c4ffac6079f2e893ebe27476944413c4f15016e3e1f360571bdcf7e22c3.jpeg",
    "https://cdn.faire.com/fastly/9eb93db9df81bc5c591a19567205d78c4c88f537cf52e232f9e09c56f7b09514.jpeg",
    "https://cdn.faire.com/fastly/dd950bd6198e5fd9e04e2b8cd6516276600e90fe0b7b056334a4164390d87994.jpeg",
    "https://cdn.faire.com/fastly/67351bc7ede1b4ddd2dee2442b71f289cd587c50da69355db3077de8503025f9.jpeg",
  ],
  priceDollars: 1.25,
  description:
    "A fun, candy-free Easter basket stuffer retailers love.\n\nThese adorable Mini Bunny Bath Bombs are an easy seasonal seller and a unique alternative to traditional Easter candy.\n\nPerfectly sized to fit inside standard plastic Easter eggs, they are ideal for Easter baskets, egg hunts, and spring gift displays.\n\nEach bunny bath bomb is handmade with all-natural ingredients and fruit-inspired scents, creating a playful bath-time treat that kids love.\nBath bombs are sold by the case pack (6 per case), and retailers can choose their color when ordering.\n\nEach bath bomb is individually shrink-wrapped with a bath bomb sticker on the back that reads “All-Natural Handmade Bath Bomb.” They arrive retail-ready and are easy to merchandise in Easter baskets, spring displays, or checkout bins.\n\nProduct Details\n• Case pack: 6 bath bombs\n• Color: Retailer selects color per case\n• Packaging: Individually shrink-wrapped\n• Label: Bath bomb sticker on back\n• Size: Fits inside standard plastic Easter eggs\n• Ingredients: All-natural formula\n• Scent: Fruity, kid-friendly fragrances\n• Handmade in small batches\nPerfect For\n• Easter basket stuffers\n• Easter egg fillers\n• Candy-free Easter gifts\n• Kids bath and self-care sections\n• Spring seasonal displays",
  tags: [],
  msrpDollars: 2.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:35.259Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
